var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { name: _vm.$options.name, novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm.data.heading
        ? [
            _c("h3", [_vm._v(_vm._s(_vm.data.heading.title))]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.data.heading.descriptionHtml) },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.error && _vm.data.error
        ? _c("div", { staticClass: "error-message" }, [
            _c("div", { staticClass: "error-message__icon" }),
            _vm._v(" "),
            _c("div", { staticClass: "error-message__text" }, [
              _c("h2", [_vm._v(_vm._s(_vm.data.error.title))]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.data.error.descriptionHtml) },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("Loading")
        : [
            _vm._l(_vm.fields, function (field) {
              return _c("Input", {
                key: field.name,
                ref: `${field.name}`,
                refInFor: true,
                attrs: {
                  name: field.name,
                  type: _vm.isPasswordField(field)
                    ? _vm.passwordFieldType
                    : field.type,
                  label: field.label,
                  placeholder: field.label,
                  startingValue: field.startingValue,
                  required: true,
                  customValidation: field.customValidation,
                  vuexPath: _vm.vuexPath,
                  pattern: field.pattern,
                  title: field.title,
                  isPassword: _vm.isPasswordField(field),
                  fieldType: _vm.passwordFieldType,
                },
                on: { "toggle-password": _vm.togglePasswordVisibility },
              })
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: {
                  type: "submit",
                  "aria-label": "Submit form",
                  title: "Submit form",
                },
              },
              [_vm._v(_vm._s(_vm.data.submitLabel))]
            ),
            _vm._v(" "),
            _vm.data.links
              ? _vm._l(_vm.data.links, function (link) {
                  return _c(
                    "p",
                    { key: link.name, staticClass: "form-links" },
                    [
                      link.label
                        ? _c("span", [_vm._v(_vm._s(link.label))])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        { attrs: { href: link.url, target: link.target } },
                        [_vm._v(_vm._s(link.name))]
                      ),
                    ]
                  )
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }